module.exports = __webpack_public_path__ + "img/icon-support.680893f9.svg";